import { WATERMARK_COLOR, WATERMARK_DENSITY } from '../interfaces';

export const COLOR_MAP: Record<WATERMARK_COLOR, string> = {
    [WATERMARK_COLOR.NORMAL]: 'rgba(0,0,0,0.09)',
    [WATERMARK_COLOR.DEEP]: 'rgba(0,0,0,0.11)',
    [WATERMARK_COLOR.LIGHT]: 'rgba(0,0,0,0.07)'
};

export const DARK_COLOR_MAP: Record<WATERMARK_COLOR, string> = {
    [WATERMARK_COLOR.NORMAL]: 'rgba(0,0,0,0.12)',
    [WATERMARK_COLOR.DEEP]: 'rgba(0,0,0,0.14)',
    [WATERMARK_COLOR.LIGHT]: 'rgba(0,0,0,0.1)'
};

export const DENSITY_MAP: Record<WATERMARK_DENSITY, [width: number, height: number]> = {
    [WATERMARK_DENSITY.DENSE]: [200, 130],
    [WATERMARK_DENSITY.NORMAL]: [260, 200],
    [WATERMARK_DENSITY.SPARSE]: [340, 260]
};
